import React, { useEffect } from "react";
import CustomerFAQs from "./CustomerFAQs";
import VendorFAQs from "./VendorFAQs";
import GeneralFAQs from "./GeneralFAQs";
import { useLocation, useNavigate } from "react-router-dom";

const FAQPage: React.FC = () => {
  const navigationOptions = [
    { title: "For Customers", id: 1, param: "customers" },
    { title: "For Vendors", id: 2, param: "vendors" },
    { title: "General Questions", id: 3, param: "general-questions" },
  ];

  const location = useLocation();
  const navigate = useNavigate();

  const queryParam = location.search.replace("?", "");

  const [selectedOption, setSelectedOption] = React.useState<number | null>(
    null
  );
  useEffect(() => {
    const aboutElement = document.getElementById("topbartopscroll");
    if (aboutElement) {
      aboutElement.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  useEffect(() => {
    const matchedOption = navigationOptions.find(
      (option) => option.param === queryParam
    );
    if (matchedOption) {
      setSelectedOption(matchedOption.id);
    } else {
      setSelectedOption(1);
      navigate("?customers", { replace: true });
    }
  }, [queryParam, navigate]);

  const handleOptionClick = (optionId: number, param: string) => {
    setSelectedOption(optionId);
    navigate(`?${param}`, { replace: true });
  };

  return (
    <div className="flex h-max flex-col">
      <div className="px-[5vw] md:px-[16vw] pt-[5vh] w-full">
        <div>
          {/* <p className="flex items-start text-[1.65vh] text-customGrayBase">
            Last modified: 10/22/2024
          </p> */}
          <h1 className="mt-[4%] font-helveticaBold text-[7.5vh] leading-none text-black">
            Frequently Asked <br /> Questions
          </h1>
        </div>
        <div className="mt-[6vh] flex">
          <div className="hidden md:flex flex-col min-w-max space-y-[2vh] text-[2vh]">
            {navigationOptions.map((option) => (
              <div
                key={option.id}
                className={`cursor-pointer text-customGrayBase ${
                  selectedOption === option.id
                    ? "text-customGreenColor font-helveticaBold"
                    : "font-normal"
                }`}
                onClick={() => handleOptionClick(option.id, option.param)}
              >
                {option.title}
              </div>
            ))}
          </div>

          <div className="w-full">
            {queryParam === "customers" ? (
              <CustomerFAQs />
            ) : queryParam === "vendors" ? (
              <VendorFAQs />
            ) : queryParam === "general-questions" ? (
              <GeneralFAQs />
            ) : (
              <CustomerFAQs />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
